unable to read source [project]/packages/core/src/mergeClasses.ts